export type SlideoutWrapperProps = {
    children: React.ReactNode,
    icon:  React.FunctionComponent<React.SVGProps<SVGSVGElement> & {
        title?: string | undefined;
    }>,
    onFirstShow?: () => void,
    btnPos?: SlideoutBtnPosition,
    disable?: boolean,
    hide?: boolean
}

export enum SlideoutBtnPosition {
    Left,
    TopRight
}